import { render, staticRenderFns } from "./DadosSistemas.vue?vue&type=template&id=00c73009&scoped=true&"
import script from "./DadosSistemas.vue?vue&type=script&lang=js&"
export * from "./DadosSistemas.vue?vue&type=script&lang=js&"
import style0 from "./DadosSistemas.vue?vue&type=style&index=0&id=00c73009&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c73009",
  null
  
)

export default component.exports